var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPopover
    ? _c(
        "el-popover",
        {
          ref: _vm.popoverRef,
          attrs: {
            placement: _vm.placement,
            "visible-arrow": _vm.visibleArrow
          },
          on: { show: _vm.onPopoverShow },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c("el-input", {
            style: { width: _vm.areaWidth },
            attrs: {
              type: "textarea",
              rows: _vm.areaRows,
              placeholder: _vm.placeholder
            },
            model: {
              value: _vm.areaValue,
              callback: function($$v) {
                _vm.areaValue = $$v
              },
              expression: "areaValue"
            }
          }),
          _c(
            "div",
            { staticStyle: { "text-align": "right", margin: "0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "text" },
                  on: {
                    click: function($event) {
                      _vm.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.onAreaTextConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              )
            ],
            1
          ),
          _c("el-input", {
            style: { width: _vm.inputWidth },
            attrs: {
              slot: "reference",
              clearable: "",
              placeholder: _vm.placeholder
            },
            slot: "reference",
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue"
            }
          })
        ],
        1
      )
    : _c("el-input", {
        style: { width: _vm.inputWidth },
        attrs: {
          disabled: _vm.inputDisabled,
          clearable: "",
          placeholder: _vm.placeholder
        },
        nativeOn: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onInputEnter($event)
          }
        },
        model: {
          value: _vm.inputValue,
          callback: function($$v) {
            _vm.inputValue = $$v
          },
          expression: "inputValue"
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }